export const API_CONSTANTS = {
  tokenGenerate: "authorizationserver/oauth/token",
  customerDetails:
    "mhkflooringBMF/users/{userId}/orgCustomers/{orgCustomerId}",
  builderList: "mhkflooringBMF/users/{userId}/getBuilderInfo",
  totalOrdersCount:
    "mhkflooringBMF/users/{userId}/builder/{builderUid}/getTotalOrdersCount",
  openOrdersCount:
    "mhkflooringBMF/users/{userId}/builder/{builderUid}/getOpenOrdersCount",
  productsCount:
    "mhkflooringBMF/users/{userId}/countSellingStyle/builder/{builderUid}",
  divisionList: "mhkflooringBMF/users/{userId}/divInfo",
  subDivisionList: "mhkflooringBMF/users/{userId}/subDivInfo",
  productStyleList:
    "mhkflooringBMF/users/{userId}/searchBmf/searchSellingStyle/builder/{builderUid}/style/{styleNumber_Or_Name}?fields=FULL&isPartNumberSearch={isPartNumberSearch}",
  // shippingAddessList: "mhkflooringBMF/users/{userId}/accounts/getAllShipTo/{accountId}",
  shippingAddessList: "mhkflooringBMF/users/{userId}/getAllAddresses",
  createCart:
    "mhkflooringBMF/users/{userId}/builder/{builderNumber}/create?confirmToCreateNewCart={createConfirm}",
  validateAddress:
    "mhkflooringBMF/users/{userId}/builder/{builderNumber}/create?confirmToCreateNewCart={createConfirm}",
  //selectShippingAddress: "mhkflooringBMF/users/setCustomerDefaultAddress?customerID={userId}&addressId={addressId}&fields=DEFAULT",
  selectShippingAddress:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/setShippingAddress?addressId={addressId}",
  oneTimeShippingAddress:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/add-one-time-shipTo-address",
  skuList:
    "mhkflooringBMF/users/{userId}/searchSellingSku/style/{styleCode}?fields=FULL",
  // uomList: "mhkflooringBMF/users/{userId}/getUomList/style/{productCode}",
  uomList:
    "mhkflooringBMF/products/{productCode}/productUOMDetails?fields=FULL",
  // atp: "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderUid}/atp",
  atp: "mhkflooringBMF/users/{userId}/atpCheck",
  addDivision:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/division/{divisionUid}/addDivisionInfoInCart",
  addSubDivision:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/subdivision/{subDivisionUid}/addSubDivisionInfoInCart?subDivisionFreeText={subDivisionFreeText}",
  addLotInfo:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderUid}/addLotInfo",
  addToCart:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderNumber}/addEntries?code={productCode}",
  orderHistory:
    "mhkflooringBMF/users/{userId}/builder/{builderNumber}/builderOrders?currentPage={currentPage}&pageSize={pageSize}&sortCode={sortCode}",
  //orderHistory: "mhkflooringBMF/users/{userId}/currentOrders?currentPage={currentPage}&pageSize={pageSize}&sortCode={sortCode}&showMode=Page&fields=DEFAULT",
  // reserveList: "mhkflooringBMF/users/{userId}/getAllUserReserves?fields=DEFAULT",
  reserveList:
    "mhkflooringBMF/reserve/users/{userId}?fields=DEFAULT&pageSize={pageSize}&currentPage={currentPage}&sort={sort}",
  // getCart: "mhkflooringBMF/users/{userId}/carts/{cartId}/viewCart",
  getCart: "mhkflooringBMF/users/{userId}/carts/{cartId}?fields=DEFAULT",
  changeQuantity:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderNumber}/changeQuantity",
  changeQuantityAddToOrder:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderNumber}/addEntries",
  cancelLine:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/removeEntry/entries/{entryNumber}",
  cancelCart: "mhkflooringBMF/users/{userId}/carts/{cartId}/removeCart",
  //  eligibilityReserverCart: "mhkflooringBMF/users/{userId}/carts/{cartId}/checkEligibilityOfCartForReserve",
  eligibilityReserverCart:
    "mhkflooringBMF/reserve/checkReserveEligibility/{cartId}",
  cancelSolution:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/cancelSolution/invoiceAccount/{accountUid}",
  // getSubmittedFor: "mhkflooringBMF/users/{userId}/getMembersForCart",
  getSubmittedForList: "mhkflooringBMF/users/{userId}/submittedForList",
  proceedTocheckout:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/placeOrderAndGetDetails?fields=DEFAULT",
  proceedToReserver:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/addProductsToReserveFromCart?projectName={projectName}",
  updateSidemark:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/entries/{entryNumber}/setSideMark?erpOrderNumber={erpOrderNumber}&sideMark={sideMark}",
  setShipAsComplete:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/setShipAsComplete?erpOrderNumber={erpOrderNumber}&shipAsComplete={shipAsComplete}",
  setPO:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/setPo?erpOrderNumber={erpOrderNumber}&poNumber={poNumber}",
  saveComments:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/saveComments?erpOrderNumber={erpOrderNumber}&comment={comment}",
  validateCart: "mhkflooringBMF/users/{userId}/carts/{cartId}/validateCart",
  sendOrderLotInfoToCams:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderUid}/sendOrderLotInfoToCams",
  placeOrderAndGetDetails:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/placeOrderAndGetDetails?fields=DEFAULT",
  getShipViaList:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/fetchShipViaList?erpOrderCode={erpOrderCode}&fields=DEFAULT",
  setShipVia:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/saveShipVia?erpOrderCode={erpOrderCode}&shipViaCode={shipViaCode}&shipViaDescription={shipViaDescription}&fields={fields}&freightCode={freightCode}&freightZone={freightZone}&functionType={functionType}",
  getReqDeliveryDates:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/getReqDeliveryDates?erpOrderNumber={erpOrderNumber}&shipComplete={shipComplete}",
  setReqDeliveryDate:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/setReqDeliveryDate?erpOrderNumber={erpOrderNumber}&date={date}",
  orderDetails: "mhkflooringBMF/users/{userId}/orders/orderDetails/{orderCode}",
  getBuilderCart:
    "mhkflooringBMF/users/{userId}/builder/{builderNumber}/getBuilderCart",
  setSubmittedFor:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/setSubmittedFor?submittedForId={uid}",
  createNewUser:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/createSubmittedFor",
  getAccessoriesForEntry:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/getAccessoriesForEntry?entryNum={entryNumber}",
  addMultiAccessoriesToCart:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderNumber}/addMultiAccessoriesToCart",
  todayShipmentOrder:
    "mhkflooringBMF/users/{userId}/todaysShipmentOrders?currentPage={currentPage}&pageSize={pageSize}&showMode=Page&sortCode={sortCode}",
  postOrderCancelLine:
    "mhkflooringBMF/users/{userId}/order/{orderCode}/entries/{entryNumber}/cancelOrderEntry?cancellationCode={cancellationCode}",
  postOrderCancel: "mhkflooringBMF/users/{userId}/orderCancel/{entryNumber}",
  postOrderGetShipViaList:
    "mhkflooringBMF/users/{userId}/order/{orderCode}/getShipViaList?erpOrderCode={erpOrderCode}",
  postOrderSaveShipVia:
    "mhkflooringBMF/users/{userId}/order/{orderCode}/saveShipViaPostOrder?erpOrderNumber={erpOrderNumber}&shipViaCode={shipViaCode}&shipViaDescription={shipViaDescription}&shipViaCarrier={shipViaCarrier}&freightCode={freightCode}&freightZone={freightZone}&functionType={functionType}",
  postOrderUpdateLotInfo:
    "mhkflooringBMF/users/{userId}/builder/{builderUid}/order/{orderCode}/addOrderLotInfo",
  postOrderChangeQuantity: "mhkflooringBMF/users/{userId}/changeOrderQuantity",
  postOrderChangeQuantityAddLine:
    "mhkflooringBMF/users/{userId}/orders/addLine?orderCode={orderNumber}&oldLineNumber={entryNumber}&cancellationCode={cancellationCode}",
  postOrderAddNewLineATP: "mhkflooringBMF/users/{userId}/orders/atp/addNewLine",
  postOrderAddNewLine:
    "mhkflooringBMF/users/{userId}/orders/addNewLine?orderCode={orderNumber}&productCode={productCode}&quantity={quantity}",
  accessoriesATP:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/builder/{builderUid}/atp",
  getPostOrderDeliveryDates:
    "mhkflooringBMF/order/getDates?erpOrderNumber={erpOrderNumber}&orderCode={orderCode}",
  setPostOrderDeliveryDate:
    "mhkflooringBMF/users/{userId}/changeOrderRequestedDate?erpOrderNumber={erpOrderNumber}&fields=DEFAULT&orderCode={orderCode}&requestedDate={requestedDate}",
  minMaxValidation:
    "mhkflooringBMF/users/{userId}/minMaxValidation?SkuId={SkuId}&fields=DEFAULT&numberOfRolls={numberOfRolls}&targetLength={targetLength}",
  addProductsToReserveFromCart:
    "mhkflooringBMF/reserve/createReserve/{cartId}/{reserveName}",
  postOrderUpdatePO: "mhkflooringBMF/users/{userId}/postOrderModification",
  ///users/csr_sujith@mohawk.com/postOrderModification
  downloadPDF:
    "mhkflooringBMF/users/{userId}/orders/downloadPDF?orderCode={orderCode}",
  sharePDF: "mhkflooringBMF/users/{userId}/orders/{orderCode}/sharePDF",
  reverseDetail: "mhkflooringBMF/reserve/{reserveNumber}/getReserveDetails",
  addReserveToCart: "mhkflooringBMF/reserve/users/{userId}/reserveToCart",
  extendReverseLine: "mhkflooringBMF/reserve/extendReserve",
  cancelReverse: "mhkflooringBMF/reserve/cancelReserve",
  postOrderCancelSolution: "mhkflooringBMF/users/{userId}/order/cancelSolution",
  excessQuantity:
    "mhkflooringBMF/users/{userId}/product/minMaxValidation?fields=DEFAULT",
  getAccounts: "mhkflooringBMF/users/{userId}/listOfB2bUnits?fields=DEFAULT",
  selectAccount:
    "mhkflooringBMF/users/{userId}/accounts/setDefaultUnit/{unitId}?checkSuffixAccount={checkSuffixAccount}",
  // csrSearch:"mhkflooringBMF/users/{userId}/findAccount/csr?filterTab={tabName}&page={pageNumber}",
  csrSearch:
    "mhkflooringBMF/users/{userId}/csrcustomer/search?filterTab={tabName}&currentPage={currentPage}&orderby={orderby}&sort={sort}&pageSize={pageSize}",
  selectCsr:
    "mhkflooringBMF/users/{userId}/selectAccount/csr?accountId={B2BUnitId}",
  exitCsr: "mhkflooringBMF/users/{userId}/exitAccount/csr",
  emailList: "mhkflooringBMF/users/{userId}/getEmailListAutoComplete",
  populateEmailsForAutoComplete:
    "mhkflooringBMF/users/{userId}/orgCustomers/populateEmailsForAutoComplete?customerQuery={customerQueries}",
  notification:
    "mhkflooringBMF/users/{userId}/getPostNotificationResidentialComponentData",
  setDefaultUnitToCSRANDSales:
    "mhkflooringBMF/users/{userId}/orgCustomers/setDefaultUnit",
  salesHierarchy: "mhkflooringBMF/user/{userId}/salesHierarchy",
  mngrHierarchy: "mhkflooringBMF/user/{userId}/salesHierarchyForMgr",
  salesmanOrderHistory:
    "mhkflooringBMF/users/{userId}/getOrders?selectedSalesMan={role}&rvpid={rvpid}&dmid={dmid}&id={id}&onChangeSalesManId={onChangeSalesManId}&page={page}&activeTab={activeTab}&salesManId={salesManId}&sortOrder={sortOrder}&sortCode={sortCode}&accountSearch={accountSearch}",
  customers: "mhkflooringBMF/users/{userId}/orgCustomers",
  // salesmanAccounts: "mhkflooringBMF/users/{userId}/fetchAccountsDetail?&dmid={dmid}&id={id}&resultsPerPage={resultsPerPage}&searchAccounttext={searchAccounttext}",
  salesmanAccounts:
    "mhkflooringBMF/users/{userId}/selectAccount/salesListAccounts?currentPage={currentPage}&pageSize={pageSize}&fields=FULL",
  selectSalesPrsonAccount:
    "mhkflooringBMF/users/{userId}/selectAccount/salesPerson?accountId={accountId}&count={count}&fields=DEFAULT&unitId={unitId}",
  csrSaveCart: "mhkflooringBMF/users/{userId}/carts/{cartId}/saveCart",
  csrValidateAccount:
    "mhkflooringBMF/users/{userId}/{invoiceAccount}/validateAccount",
  changeHeirarchy:
    "mhkflooringBMF/user/{userId}/childHierarchy?salesHierarchyRole={salesHierarchyRole}&salesHierarchyCode={salesHierarchyCode}",
  validateAccount:
    "mhkflooringBMF/users/{userId}/{invoiceAccount}/validateAccount",
  getTermsCodeList:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/termsCodesForSalesPerson",
  getTermsReasonList:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/termsReasonForSalesPerson",
  updateTermsCode:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/entries/{entries}/updateTermsCodeAndDescription?termsCode={termsCode}&termsCodeDescription={termsCodeDescription}",
  updateTermsReason:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/entries/{entries}/updateTermsReasonAndDescription?termsReason={termsReason}&termsReasonDescription={termsReasonDescription}",
  slaesPersonAccountList:
    "mhkflooringBMF/users/{userId}/accounts/getSalesPersonAccounts",
  // MohawkXchange Endpoint
  setUnit:
    "mhkflooringBMF/users/{userId}/orgCustomers/setDefaultUnit?unitUid={unitUid}",
  getDefaultShippingAddress:
    "mhkflooringBMF/users/{userId}/getDefaultShippingAddress?fields=DEFAULT&isSample={isSample}",
  miniCart: "mhkflooringBMF/users/{uid}/{customerNumber}/miniCart",
  addToCartCrest: "mhkflooringBMF/carts/{cartId}/users/{userId}/addToCart",
  // addToCartCrest: "mhkflooringBMF/users/{userId}/carts/{cartId}/addToCart",
  orderReview: "mhkflooringBMF/users/{userId}/carts/{cartId}/orderReview",
  getShippingWareHouse: "mhkflooringBMF/users/{userId}/getShippingWarehouses",
  getIncoTermsLoc:
    "mhkflooringBMF/users/{userId}/getShipviaList?incotermsLocation={incotermsLocation}&zipCode={zipCode}",
  validatePO: "mhkflooringBMF/{cartId}/validatePO?poNumber={poNumber}",
  submitOrder: "mhkflooringBMF/{userId}/{cartId}/submitOrder",
  orderDetailsForOrderCode:
    "mhkflooringBMF/users/{userId}/getOrderDetailsForOrderCode?orderCode={orderCode}",
  getShippingMethodList:
    "mhkflooringBMF/orgUsers/{userId}/getShippingMethod?zipCode={zipCode}&isCustomer={isCustomer}&isOneTimeShipTo={isOneTimeShipTo}&shippingMethod={shippingMethod}",
  getIncoTermsList:
    "mhkflooringBMF/users/{userId}/incoTerms?shippingMethod={shippingMethod}",
  getShippingWareHouseList:
    "mhkflooringBMF/users/{userId}/getShippingWarehouses",
  getShippingViaList:
    "mhkflooringBMF/users/{userId}/getShipviaList?incotermsLocation1={incotermsLocation1}&zipCode={zipCode}&shippingMethod={shippingMethod}",
  getOrgCustomers:
    "mhkflooringBMF/users/{userId}/orgCustomers/populateSuffix?selectedAccount={accoundUid}",
  getProductPriceDetails:
    "mhkflooringBMF/products/{productCode}/productPriceDetails?fields=FULL",
  getSalesPersonOrderList:
    "mhkflooringBMF/users/{userId}/currentOrders?currentPage={currentPage}&pageSize={pageSize}&sortCode={sortCode}&showMode=Page&fields=DEFAULT",
  deleteLine:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/entries/{entryNumber}",
  postOrderEligibility:
    "mhkflooringBMF/users/{userId}/postOrderEligibility/{code}",
  cancelReasonList:
    "mhkflooringBMF/users/{userId}/getSecndryAttributes?secAttrType={type}",
  shareOrderToEmail: "https://mohawkmailcdp.azurewebsites.net/email",
  productDetails:
    "mhkflooringBMF/products/{productCode}/productDetails?fields=FULL",
  reqDeliveryEnabledDates:
    "mhkflooringBMF/users/{userId}/getReqDeliveryDates?shipToUnit={shipToUnit}",
  salesHierarchyforSalesOps:
    "mhkflooringBMF/user/{userId}/salesHierarchyforSalesOps",
  checkAvailability: "mhkflooringBMF/users/{userId}/atpCheck",
  productMedias:
    "mhkflooringBMF/products/{productCode}/productMedias?fields=FULL",
  getMinMaxRollLength:
    "mhkflooringBMF/products/getMinMaxRoll?targetLength={standardRollLength}&productCode={productCode}&shipTo={shipTo}&soldTo={soldTo}&uom={uom}",
  allAccessoryData: "mhkflooringBMF/products/getallaccessories/{productId}",
  postOrderUpdate: "mhkflooringBMF/users/{userId}/postOrderModification",
  getPaymentTermsList:
    "mhkflooringBMF/users/{userId}/getTermsCodeList?isSampleProduct={isSampleProduct}&isPackage={isPackage}%20%20%20%20&merchandisingProduct={merchandisingProduct}&cartId={cartId}&orderId={orderId}",
  accessoryPriceSearch:
    "mhkflooringBMF/users/{userId}/pricing/accessory-price-search?accountNumber={accountNumber}",
  addLineOrAccessories: "mhkflooringBMF/users/{userId}/addLineOrAccessories",
  CancelReason:
    "mhkflooringBMF/users/{userId}/getSecndryAttributes?secAttrType={type}",
  validateShipVia:
    "mhkflooringBMF/users/{userId}/validateShipVia?shippingMethod={shippingMethod}&shipVia={shipVia}",
  getShippingOptions:
    "mhkflooringBMF/users/{userId}/getShippingOptions?fields=DEFAULT&isSample={isSample}&productCode={productCode}&shipTo={shipTo}&soldTo={soldTo}",
  postOrderModificationNew:
    "mhkflooringBMF/users/{userId}/postOrderModification",
  pdpData: "mhkflooringBMF/products/",
  UOMDetails:
    "mhkflooringBMF/products/{productId}/productUOMDetails?fields=FULL",
  getIncoTerms:
    "mhkflooringBMF/users/{userId}/incoTerms?shippingMethod={shippingMethod}",
  getIncoTermsLoc2:
    "mhkflooringBMF/users/{userId}/getShipviaList?incotermsLocation1={incotermsLocation1}&zipCode={zipCode}&shippingMethod={shippingMethod}",
  isShippingMethodReAtpRequired:
    "mhkflooringBMF/users/{userId}/isShippingMethodReAtpRequired?shippingConditionFrom={shippingConditionFrom}&shippingConditionTo={shippingConditionTo}",
  updatePostOrderEntry: "mhkflooringBMF/users/{userId}/updatePostOrderEntry",
  getAllAddressesCount: "mhkflooringBMF/users/{userId}/getAllAddressesCount",
  setDefaultAddress:
    "mhkflooringBMF/users/{userId}/orgCustomers/setDefaultAddress?addressId={addressId}",
  profileShippingPreferences:
    "mhkflooringBMF/users/{userId}/orgCustomers/shippingAddress",
  validateShippingOptionsV1:
    "mhkflooringBMF/users/{userId}/validateShippingOptions?incoLocation={incoLocation}&productCat={productCat}&shipVia={shipVia}",
  noChargeReasonCodes:
    "mhkflooringBMF/users/{userId}/getSecndryAttributes?secAttrType=NO_CHARGE_REASON_CODE",
  validateShippingOptions:
    "mhkflooringBMF/users/{userId}/validateShippingOptions?incoLocation={incoTerm}&productCat={productCategory}&shipVia={shipVia}",
  cartToCheckout: "mhkflooringBMF/users/{userId}/carts/{cartId}/checkout",
  getCustomerList: "customerlists",
  listAutocomplete: "customers/autocomplete",
  // emulateCustomer: "emulateCustomer",
  // stopSession: "end-emulation",
  getActiveBuilders: "mhkflooringBMF/users/{userId}/activeBuilders",
  getShipmentReport: "mhkflooringBMF/users/{userId}/getBuilderShipmentOrders",
  validateShipperAccount:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/validateShipperAccount?zipcode={zipCode}&accountNumber={accoundNum}&carrierType={carrierID}",
  getSmallParcelCarriers:
    "mhkflooringBMF/users/{userId}/getSmallParcelCarriers",
  updateSmallParcelFields:
    "mhkflooringBMF/carts/{cartId}/updateSmallParcelFields",
  validateSmallParcel:
    "mhkflooringBMF/carts/{cartId}/validateCartForSmallParcel",
  smallParcelShippingCondition:
    "mhkflooringBMF/users/{userId}/getSmallParcelShippingConditions?carrier={carrierId}",
  getShippingoptionForCustomers:
    "mhkflooringBMF/users/{userId}/shippingOptionsForCustomer?zipCode={code}&shippingCondition={shippingCondition}&shippingWarehouse={shippingWareHouse}&isOneTimeShipTo={isOneTimeShipTo}&b2bUnitId={b2bUnitId}",
  getDefaultUnit: "mhkflooringBMF/users/{userId}/orgCustomers/getDefaultUnit",
  getMultipleAccounts:
    "mhkflooringBMF/users/{userId}/orgCustomers/getMultiAccounts",
  getCsrCustomers:
    "us_b2b_residential/users/{userId}/csrcustomer/search?currentPage={currentPage}&fields=DEFAULT&pageSize={pageSize}&showMode=Page",
  validatePasskey: "us_b2b_residential/users/{userId}/validatePassKey",
  productVariantMatrix:
    "mhkflooringBMF/products/{productId}/productVariantMatrix?fields={fields}",
  requestPrice:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/entries/{entryNumber}/changePrice?requestedPrice={price}&priceComment={comment}",
  removeATPCartEntry: "mhkflooringBMF/users/{userId}/removeATPCartEntry",
  submitBuilderInfo:
    "mhkflooringBMF/users/{userId}/carts/{cartId}/submitBuilderInfo",
  getSubProductTypeList:
    "mhkflooringBMF/users/{userId}/getSubProductTypeList?productType={productType}",
  getCamsOrderDetails: "mhkflooringBMF/users/{userId}/getCamsOrderDetails", 
   virtualServicesAddressValidate: "mhkflooringBMF/users/{userId}/camsAddressValidation",
};
